import styled from 'styled-components';
import colors from '../../theme/constants/colors';
import typography from '../../theme/typography';

export const StyledShapeSelectorContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export const StyledShapeSelector = styled.span`
  cursor: pointer;
  width: 25%;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      .landscape,
      .portrait,
      .square,
      .oval {
        border: 2px solid ${colors.obsidian};
      }

      .shapeLabel {
        font-weight: bold;
      }
    }
  }

  &.selected {
    .landscape,
    .portrait,
    .square,
    .oval {
      border: 2px solid ${colors.red100};
    }

    .shapeLabel {
      font-weight: bold;
      color: ${colors.red100};
    }
  }

  .landscape,
  .portrait,
  .square,
  .oval {
    border: 1px solid ${colors.obsidian};
    margin: 1px auto 10px auto;
    box-sizing: border-box;
  }

  .landscape {
    width: 69px;
    height: 45px;
  }

  .portrait {
    width: 37px;
    height: 45px;
  }

  .square {
    width: 45px;
    height: 45px;
  }

  .oval {
    width: 45px;
    height: 45px;
    border-radius: 50%;
  }

  .shapeLabel {
    ${typography.Body3}
    text-align: center;
    text-transform: capitalize;
  }
`;
